/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_TitleInputs */

const en_how_we_work_brief_title = /** @type {(inputs: How_We_Work_Brief_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First-system brief`)
};

const lv_how_we_work_brief_title = /** @type {(inputs: How_We_Work_Brief_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirmās sistēmas apraksts`)
};

/**
* | output |
* | --- |
* | "First-system brief" |
*
* @param {How_We_Work_Brief_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_title = /** @type {((inputs?: How_We_Work_Brief_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_title(inputs)
	return en_how_we_work_brief_title(inputs)
});